import { HOTSPOT_TYPES } from '../../../hooks/store/Types';
import DefaultHotspot from './DefaultHotspot';
import PointHotspot from './PointHotspot';
import SceneHotspot from './SceneHotspot';

const Hotspot = (props) => {
    
    const { hotspot } = props;

    switch (hotspot.hotspotType) {
        case HOTSPOT_TYPES.MOVE:
            return <SceneHotspot {...props} />
        
        case HOTSPOT_TYPES.DATA:
            return <PointHotspot {...props} />
    
        default:
            return <DefaultHotspot {...props} />
    }
    
};

export default Hotspot;